import { ComponentProps, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Toast } from '../../';

type ToastProps = ComponentProps<typeof Toast>;

/**
 * トーストの表示と閉じるハンドラーを提供する
 *
 * @returns {Object} トーストの表示と閉じるハンドラー
 * @returns {Array} toasts トーストの配列
 * @returns {Function} showToast トーストを表示するハンドラー
 * @returns {Function} closeToast トーストを閉じるハンドラー
 */
export const useToastHandler = () => {
  const [toasts, setToasts] = useState<ToastProps[]>([]);

  const showToast = toast =>
    setToasts(prevToasts => [...prevToasts, { ...toast, toastId: uuidv4() }]);

  const closeToast = removeToastId =>
    setToasts(prevToasts => prevToasts.filter(toast => toast.toastId !== removeToastId));

  return { toasts, showToast, closeToast };
};
